import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { blogIntentForUser, dismissBlogGuide } from '../services/blogConversion';

export function BlogFirstScanGuide({ userId, createdAt, onScan, onUpload }: {
  userId: string; createdAt: Date | null | undefined; onScan: () => void; onUpload: () => void;
}) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);
  const intent = blogIntentForUser(userId, createdAt);
  if (dismissed || !intent || intent.dismissed || intent.stages.includes('first_scan')) return null;
  const dismiss = () => { dismissBlogGuide(); setDismissed(true); };
  return (
    <aside className="m-4 rounded-[2rem] border border-emerald-400/20 bg-[#111c2d] p-6 text-white">
      <h2 className="text-xl font-black uppercase tracking-tighter">{t('blog_conversion.guide_title', { defaultValue: 'Start with one receipt' })}</h2>
      <p className="mt-3 text-sm leading-relaxed text-white/65">{t('blog_conversion.guide_description', { defaultValue: 'Take a clear photo or upload a receipt. Review the items, then archive your trip to keep your price history.' })}</p>
      <div className="mt-5 flex flex-wrap gap-3">
        <button type="button" onClick={onScan} className="rounded-full bg-emerald-400 px-5 py-3 text-sm font-black text-[#050810]">{t('blog_conversion.scan', { defaultValue: 'Scan a receipt' })}</button>
        <button type="button" onClick={onUpload} className="rounded-full border border-white/20 px-5 py-3 text-sm font-bold">{t('blog_conversion.upload', { defaultValue: 'Upload a receipt' })}</button>
        <button type="button" onClick={dismiss} className="px-3 py-3 text-sm text-white/60">{t('common.dismiss', { defaultValue: 'Dismiss' })}</button>
      </div>
    </aside>
  );
}
